module.exports = __webpack_public_path__ + "static/img/xiazailuxiang.c049818.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/xiazailuxiang.png
// module id = GrA0
// module chunks = 24